import React, { useState, useEffect } from "react";
import "../SideBar_1/Dashboard.css";
import { Image, Col, Row } from "react-bootstrap";
import Loader from "../../Components/Loader/Loader";
import couponpic1 from "../../assets/tc-1.svg";
import couponpic2 from "../../assets/cou-(2).svg";
import couponpic3 from "../../assets/date.svg";
import couponpic4 from "../../assets/cou-(4).svg";
import { CouponsDashboardAPI } from "./../API/Coupons/CouponsDashboard";
import { Graph_C } from "./Graph_C";
import CouponsSummary from "./CouponsSummary";
import TopCoupons from "./TopCoupons";
import v1 from "../../assets/v-1.svg";
import v2 from "../../assets/v-2.svg";
import TopCouponsNew from "./TopCouponsNew";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

const CouponsDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [blockData, setBlockData] = useState([]);
  const [GraphData, setGraphData] = useState([]);
  const [GraphData1, setGraphData1] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [TableData, setTableData] = useState([]);
  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);

  // search
  const [searchValue, setsearchValue] = useState("");
  // sort-["coupon_name","bi_name","download_count","redeemed_count"]
  const [flag, setFlag] = useState({
    business_name: 0,
    coupon_name: 0,
    voucher_active: 0,
    download_count: 0,
    redeemed_count: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    ApiLoad();
  }, [pageNumber]);

  const ApiLoad = async () => {
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      start_date: "",
      end_date: "",
      search_value: searchValue,
      offset: searchValue ? 0 : pageNumber,
      search_value: searchValue,
    };
    const coupondetailData = await CouponsDashboardAPI(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData.status === 429) {
      swal({
        title: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else {
      setTableData(coupondetailData.data.top_coupons);
      // pagination
      setTotalPageCount(coupondetailData.data.top_coupons_rows);
      setLimit(coupondetailData.data.limit);

      setBlockData(coupondetailData.data.top_section);
      setSummaryData(coupondetailData.data.coupon_summary);
      setGraphData(coupondetailData.data.downloaded_coupons_of_week);
      setGraphData1(coupondetailData.data.redeemed_coupons_of_week);
    }
  };

  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length == 0) {
      ApiLoad();
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = async (e) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      start_date: "",
      end_date: "",
      search_value: searchValue,
      offset: searchValue ? 0 : pageNumber,
    };
    const coupondetailData = await CouponsDashboardAPI(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      swal({
        title: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else if (coupondetailData.success == false) {
      setLoading(false);
    } else {
      setLoading(false);
      setTableData(coupondetailData.data.top_coupons);
      // pagination
      setTotalPageCount(coupondetailData.data.top_coupons_rows);
      setLimit(coupondetailData.data.limit);

      setBlockData(coupondetailData.data.top_section);
      setSummaryData(coupondetailData.data.coupon_summary);
      setGraphData(coupondetailData.data.downloaded_coupons_of_week);
      setGraphData1(coupondetailData.data.redeemed_coupons_of_week);
    }
  };

  // sort
  // Api for sort
  const handleSort = async (search, sortNo, colValue) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      offset: search ? 0 : pageNumber,
      search_value: search,
      column_name: colValue,
      sort_type: sortNo,
    };
    const coupondetailData = await CouponsDashboardAPI(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData.status === 429) {
      swal({
        title: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else {
      setTableData(coupondetailData.data.top_coupons);
    }
  };

  // function to sort-button
  const HandleSortCol = (value) => {
    // coupon_name: 0,
    if (value == "coupon_name") {
      if (flag.coupon_name === 0) {
        handleSort(searchValue, 1, "coupon_name");
        setFlag((item) => {
          return { ...item, coupon_name: 1 };
        });
      } else if (flag.coupon_name === 1) {
        handleSort(searchValue, 2, "coupon_name");
        setFlag((item) => {
          return { ...item, coupon_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "coupon_name");
        setFlag((item) => {
          return { ...item, coupon_name: 0 };
        });
      }
    }
    // business_name: 0,
    if (value == "bi_name") {
      if (flag.business_name === 0) {
        handleSort(searchValue, 1, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 1 };
        });
      } else if (flag.business_name === 1) {
        handleSort(searchValue, 2, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 0 };
        });
      }
    }
    // download_count:0
    if (value == "download_count") {
      if (flag.download_count === 0) {
        handleSort(searchValue, 1, "download_count");
        setFlag((item) => {
          return { ...item, download_count: 1 };
        });
      } else if (flag.download_count === 1) {
        handleSort(searchValue, 2, "download_count");
        setFlag((item) => {
          return { ...item, download_count: 2 };
        });
      } else {
        handleSort(searchValue, 0, "download_count");
        setFlag((item) => {
          return { ...item, download_count: 0 };
        });
      }
    }
    // voucher_active: 0,
    if (value == "voucher_active") {
      if (flag.voucher_active === 0) {
        handleSort(searchValue, 1, "voucher_active");
        setFlag((item) => {
          return { ...item, voucher_active: 1 };
        });
      } else if (flag.voucher_active === 1) {
        handleSort(searchValue, 2, "voucher_active");
        setFlag((item) => {
          return { ...item, voucher_active: 2 };
        });
      } else {
        handleSort(searchValue, 0, "voucher_active");
        setFlag((item) => {
          return { ...item, voucher_active: 0 };
        });
      }
    }
    // redeemed_count
    if (value == "redeemed_count") {
      if (flag.redeemed_count === 0) {
        handleSort(searchValue, 1, "redeemed_count");
        setFlag((item) => {
          return { ...item, redeemed_count: 1 };
        });
      } else if (flag.redeemed_count === 1) {
        handleSort(searchValue, 2, "redeemed_count");
        setFlag((item) => {
          return { ...item, redeemed_count: 2 };
        });
      } else {
        handleSort(searchValue, 0, "redeemed_count");
        setFlag((item) => {
          return { ...item, redeemed_count: 0 };
        });
      }
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <Row className="dashboard-card mt-4 pt-2 newcoupon">
        <Col md="6" lg="4" className="mb-2">
          <div className="card">
            <div className="dash_c-img-main mt-1">
              <div className="dash_c-img">
                <Image src={couponpic1} height="28px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Total Lifetime Coupons</p>
              <p className="dash-text2">
                {summaryData.total_unique_coupon == null
                  ? "0"
                  : summaryData.total_unique_coupon}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>

        {/*  */}
        <Col md="6" lg="4" className="mb-2">
          <div className="card">
            <div className="dash_c-img-main mt-1">
              <div className="dash_c-img">
                <Image src={v1} height="16px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Lifetime Coupons Downloaded</p>
              <p className="dash-text2">
                {summaryData.downloaded_coupons == null
                  ? "0"
                  : summaryData.downloaded_coupons}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>

        {/*  */}
        <Col md="6" lg="4" className="mb-2">
          <div className="card">
            <div className="dash_c-img-main mt-1">
              <div className="dash_c-img">
                <Image src={v2} height="16px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Lifetime Coupons redeemed</p>
              <p className="dash-text2">
                {summaryData.coupons_redeemed == null
                  ? "0"
                  : summaryData.coupons_redeemed}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>

        <Col md="6" lg="4" className="mb-2">
          <div className="card">
            <div className="dash_c-img-main mt-1">
              <div className="dash_c-img">
                <Image src={v1} height="16px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Lifetime Coupons Unredeemed</p>
              <p className="dash-text2">
                {summaryData.un_redeemed_coupons == null
                  ? "0"
                  : summaryData.un_redeemed_coupons}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>

        {/* <Col md="6" lg="3" className='mb-2'>
              <div className="card">
                <div className="dash_c-img-main mt-1">
                  <div className="dash_c-img">
                    <Image src={couponpic3} height="28px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">New Coupons<br/> this month</p>
                  <p className="dash-text2">
                   {blockData.new_coupons_of_this_month}
                  </p>
                  <p className="text-right pb-4"></p>
                </div>
              </div>
            </Col> */}
      </Row>

      {/* graph */}
      <Graph_C
        GraphData={GraphData}
        GraphData1={GraphData1}
        setGraphData1={setGraphData1}
        setGraphData={setGraphData}
        setLoading={setLoading}
      />
      {/* summary */}
      {/* <Row>
           <Col md="12">
            <CouponsSummary summaryData={summaryData}/>
           </Col>
          </Row> */}
      {/* table */}
      <div className="mt-4">
        <TopCouponsNew
          TableData={TableData}
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
          handleSearchInput={handleSearchInput}
          handleKeypress={handleKeypress}
          handleSearch={handleSearch}
          searchValue={searchValue}
          HandleSortCol={HandleSortCol}
          flag={flag}
        />
      </div>
    </>
  );
};

export default CouponsDashboard;
